export default __webpack_public_path__ + "0701ecdcfe182d9f52cd440954c2ce59.png";